import { render, staticRenderFns } from "./activities-list-slider.component.vue?vue&type=template&id=1c0e2861&scoped=true"
import script from "./activities-list-slider.component.ts?vue&type=script&lang=ts&external"
export * from "./activities-list-slider.component.ts?vue&type=script&lang=ts&external"
import style0 from "./activities-list-slider.component.scss?vue&type=style&index=0&id=1c0e2861&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e2861",
  null
  
)

export default component.exports